import React from "react";
import withContext from "../utils/withContext";
import AdfoxAdaptive from "../components/AdFoxAdaptive";
import * as versions from "./version";

function getOptions(context) {
    return [
        {
            ownerId: 407082,
            containerId: "adfox_158591889817585646",
            params: {
                p1: "ctkpv",
                p2: "hpbv",
                'partner-stat-id': context.analytics_lable
            },
        },
        ["tablet", "phone"],
        {
            tabletWidth: 830,
            phoneWidth: 480,
            isAutoReloads: false,
        },
    ];
}

export function AdfoxBottomOverlay({ context }) {
    const options = getOptions(context);

    if (!options) {
        return null;
    }

    return <AdfoxAdaptive options={options} />;
}

export default withContext(AdfoxBottomOverlay);
